module.exports = __webpack_public_path__ + "img/mortgages-main.05582c9.png";